import * as Types from '../../../generated/webapp_gql';

import { ProgramPreviewFragment, ProgramFragment, ProgramPageFragment } from '../../newPrograms/documents/getProgram.generated';
import { gql } from 'graphql.macro';
import { ProgramPreviewFragmentDoc, ProgramFragmentDoc, ProgramPageFragmentDoc } from '../../newPrograms/documents/getProgram.generated';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions =  {}
export type ScreenLink_ProgramLinkNode_Fragment = (
  { __typename?: 'ProgramLinkNode' }
  & Pick<Types.ProgramLinkNode, 'id'>
  & { program: (
    { __typename?: 'ProgramNode' }
    & Pick<Types.ProgramNode, 'uuid'>
    & ProgramPreviewFragment
  ) }
);

export type ScreenLink_MeditationLinkNode_Fragment = (
  { __typename?: 'MeditationLinkNode' }
  & Pick<Types.MeditationLinkNode, 'id'>
  & { meditation: (
    { __typename?: 'MeditationNode' }
    & Pick<Types.MeditationNode, 'uuid' | 'name' | 'slug' | 'description' | 'image'>
  ) }
);

export type ScreenLink_InternalLinkNode_Fragment = (
  { __typename?: 'InternalLinkNode' }
  & Pick<Types.InternalLinkNode, 'id' | 'path' | 'title' | 'subtitle' | 'image'>
);

export type ScreenLink_ExternalLinkNode_Fragment = (
  { __typename?: 'ExternalLinkNode' }
  & Pick<Types.ExternalLinkNode, 'id' | 'url' | 'title' | 'subtitle' | 'image'>
);

export type ScreenLink_CircleTopicLinkNode_Fragment = (
  { __typename?: 'CircleTopicLinkNode' }
  & Pick<Types.CircleTopicLinkNode, 'id'>
  & { circleTopic?: Types.Maybe<(
    { __typename?: 'CircleTopicNode' }
    & Pick<Types.CircleTopicNode, 'name' | 'description' | 'slug' | 'duration' | 'format'>
    & { sessions: (
      { __typename?: 'CircleSessionConnection' }
      & { edges: Array<Types.Maybe<(
        { __typename?: 'CircleSessionEdge' }
        & { node: (
          { __typename?: 'CircleSessionNode' }
          & Pick<Types.CircleSessionNode, 'startTime'>
        ) }
      )>> }
    ) }
  )> }
);

export type ScreenLink_CircleSeriesLinkNode_Fragment = (
  { __typename?: 'CircleSeriesLinkNode' }
  & Pick<Types.CircleSeriesLinkNode, 'id'>
  & { circleSeries?: Types.Maybe<(
    { __typename?: 'CircleSeriesNode' }
    & Pick<Types.CircleSeriesNode, 'id' | 'name' | 'illustration' | 'slug'>
    & { topics: (
      { __typename?: 'CircleTopicConnection' }
      & { edges: Array<Types.Maybe<(
        { __typename?: 'CircleTopicEdge' }
        & { node: (
          { __typename?: 'CircleTopicNode' }
          & Pick<Types.CircleTopicNode, 'id' | 'duration'>
        ) }
      )>> }
    ) }
  )> }
);

export type ScreenLink_CircleSessionLinkNode_Fragment = (
  { __typename?: 'CircleSessionLinkNode' }
  & Pick<Types.CircleSessionLinkNode, 'id'>
  & { circleSession?: Types.Maybe<(
    { __typename?: 'CircleSessionNode' }
    & Pick<Types.CircleSessionNode, 'seatsLeft' | 'rsvpLink'>
    & { topic: (
      { __typename?: 'CircleTopicNode' }
      & Pick<Types.CircleTopicNode, 'name'>
    ) }
  )> }
);

export type ScreenLink_ScreenLinkNode_Fragment = (
  { __typename?: 'ScreenLinkNode' }
  & Pick<Types.ScreenLinkNode, 'id'>
);

export type ScreenLinkFragment = ScreenLink_ProgramLinkNode_Fragment | ScreenLink_MeditationLinkNode_Fragment | ScreenLink_InternalLinkNode_Fragment | ScreenLink_ExternalLinkNode_Fragment | ScreenLink_CircleTopicLinkNode_Fragment | ScreenLink_CircleSeriesLinkNode_Fragment | ScreenLink_CircleSessionLinkNode_Fragment | ScreenLink_ScreenLinkNode_Fragment;

export type ScreenSectionFragment = (
  { __typename?: 'ScreenSectionNode' }
  & Pick<Types.ScreenSectionNode, 'id' | 'uuid' | 'index' | 'renderComponent' | 'minimumMobileVersion' | 'title' | 'subtitle'>
  & { ctaLink?: Types.Maybe<(
    { __typename?: 'ProgramLinkNode' }
    & Pick<Types.ProgramLinkNode, 'id'>
    & ScreenLink_ProgramLinkNode_Fragment
  ) | (
    { __typename?: 'MeditationLinkNode' }
    & Pick<Types.MeditationLinkNode, 'id'>
    & ScreenLink_MeditationLinkNode_Fragment
  ) | (
    { __typename?: 'InternalLinkNode' }
    & Pick<Types.InternalLinkNode, 'id'>
    & ScreenLink_InternalLinkNode_Fragment
  ) | (
    { __typename?: 'ExternalLinkNode' }
    & Pick<Types.ExternalLinkNode, 'id'>
    & ScreenLink_ExternalLinkNode_Fragment
  ) | (
    { __typename?: 'CircleTopicLinkNode' }
    & Pick<Types.CircleTopicLinkNode, 'id'>
    & ScreenLink_CircleTopicLinkNode_Fragment
  ) | (
    { __typename?: 'CircleSeriesLinkNode' }
    & Pick<Types.CircleSeriesLinkNode, 'id'>
    & ScreenLink_CircleSeriesLinkNode_Fragment
  ) | (
    { __typename?: 'CircleSessionLinkNode' }
    & Pick<Types.CircleSessionLinkNode, 'id'>
    & ScreenLink_CircleSessionLinkNode_Fragment
  ) | (
    { __typename?: 'ScreenLinkNode' }
    & Pick<Types.ScreenLinkNode, 'id'>
    & ScreenLink_ScreenLinkNode_Fragment
  )>, contentCollectionLinks: Array<(
    { __typename?: 'ProgramLinkNode' }
    & Pick<Types.ProgramLinkNode, 'id'>
    & ScreenLink_ProgramLinkNode_Fragment
  ) | (
    { __typename?: 'MeditationLinkNode' }
    & Pick<Types.MeditationLinkNode, 'id'>
    & ScreenLink_MeditationLinkNode_Fragment
  ) | (
    { __typename?: 'InternalLinkNode' }
    & Pick<Types.InternalLinkNode, 'id'>
    & ScreenLink_InternalLinkNode_Fragment
  ) | (
    { __typename?: 'ExternalLinkNode' }
    & Pick<Types.ExternalLinkNode, 'id'>
    & ScreenLink_ExternalLinkNode_Fragment
  ) | (
    { __typename?: 'CircleTopicLinkNode' }
    & Pick<Types.CircleTopicLinkNode, 'id'>
    & ScreenLink_CircleTopicLinkNode_Fragment
  ) | (
    { __typename?: 'CircleSeriesLinkNode' }
    & Pick<Types.CircleSeriesLinkNode, 'id'>
    & ScreenLink_CircleSeriesLinkNode_Fragment
  ) | (
    { __typename?: 'CircleSessionLinkNode' }
    & Pick<Types.CircleSessionLinkNode, 'id'>
    & ScreenLink_CircleSessionLinkNode_Fragment
  ) | (
    { __typename?: 'ScreenLinkNode' }
    & Pick<Types.ScreenLinkNode, 'id'>
    & ScreenLink_ScreenLinkNode_Fragment
  )> }
);

export type ScheduledContentFragment = (
  { __typename?: 'ScheduledContentNode' }
  & Pick<Types.ScheduledContentNode, 'uuid' | 'contentType' | 'startTime' | 'bannerTitle' | 'bannerContent' | 'bannerCtaText' | 'bannerImage' | 'headerImage' | 'accentColor' | 'titleColor' | 'fullContent' | 'linkHeader'>
  & { scheduledContentLinks: Array<(
    { __typename?: 'ScheduledContentLinkNode' }
    & Pick<Types.ScheduledContentLinkNode, 'uuid' | 'image' | 'index' | 'title' | 'subtitle' | 'linkType' | 'mobileValue' | 'webValue' | 'isCta'>
  )>, myActivity?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'ScheduledContentActivityNode' }
    & Pick<Types.ScheduledContentActivityNode, 'activityType'>
  )>>> }
);

export type ScreenFragment = (
  { __typename?: 'HomeScreenNode' }
  & Pick<Types.HomeScreenNode, 'id' | 'uuid' | 'name' | 'platform'>
  & { scheduledContent?: Types.Maybe<(
    { __typename?: 'ScheduledContentNode' }
    & Pick<Types.ScheduledContentNode, 'uuid'>
    & ScheduledContentFragment
  )>, screenSections: Array<Types.Maybe<(
    { __typename?: 'ScreenSectionNode' }
    & Pick<Types.ScreenSectionNode, 'id'>
    & ScreenSectionFragment
  )>> }
);

export type GetHomeScreenQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetHomeScreenQuery = (
  { __typename?: 'Query' }
  & { homeScreen?: Types.Maybe<(
    { __typename?: 'HomeScreenNode' }
    & Pick<Types.HomeScreenNode, 'id'>
    & ScreenFragment
  )> }
);

export const ScheduledContentFragmentDoc = gql`
    fragment ScheduledContent on ScheduledContentNode {
  uuid
  contentType
  startTime
  bannerTitle
  bannerContent
  bannerCtaText
  bannerImage
  headerImage
  accentColor
  titleColor
  fullContent
  linkHeader
  scheduledContentLinks {
    uuid
    image
    index
    title
    subtitle
    linkType
    mobileValue
    webValue
    isCta
  }
  myActivity {
    activityType
  }
}
    `;
export const ScreenLinkFragmentDoc = gql`
    fragment ScreenLink on ContentLinkNode {
  ... on Node {
    id
  }
  ... on ProgramLinkNode {
    program {
      uuid
      ...ProgramPreview
    }
  }
  ... on MeditationLinkNode {
    meditation {
      uuid
      name
      slug
      description
      image
    }
  }
  ... on ExternalLinkNode {
    url
    title
    subtitle
    image
  }
  ... on InternalLinkNode {
    path
    title
    subtitle
    image
  }
  ... on CircleSessionLinkNode {
    circleSession {
      topic {
        name
      }
      seatsLeft
      rsvpLink
    }
  }
  ... on CircleTopicLinkNode {
    circleTopic {
      name
      description
      slug
      duration
      format
      sessions {
        edges {
          node {
            startTime
          }
        }
      }
    }
  }
  ... on CircleSeriesLinkNode {
    circleSeries {
      id
      name
      illustration
      slug
      topics {
        edges {
          node {
            id
            duration
          }
        }
      }
    }
  }
}
    ${ProgramPreviewFragmentDoc}`;
export const ScreenSectionFragmentDoc = gql`
    fragment ScreenSection on ScreenSectionNode {
  id
  uuid
  index
  renderComponent
  minimumMobileVersion
  ctaLink {
    ... on Node {
      id
    }
    ...ScreenLink
  }
  title
  subtitle
  contentCollectionLinks {
    ... on Node {
      id
    }
    ...ScreenLink
  }
}
    ${ScreenLinkFragmentDoc}`;
export const ScreenFragmentDoc = gql`
    fragment Screen on HomeScreenNode {
  id
  uuid
  name
  platform
  scheduledContent @client {
    uuid
    ...ScheduledContent
  }
  screenSections @client {
    id
    ...ScreenSection
  }
}
    ${ScheduledContentFragmentDoc}
${ScreenSectionFragmentDoc}`;
export const GetHomeScreenDocument = gql`
    query getHomeScreen {
  homeScreen(platform: WEB) @client {
    id
    ...Screen
  }
}
    ${ScreenFragmentDoc}
${ScheduledContentFragmentDoc}
${ScreenSectionFragmentDoc}
${ScreenLinkFragmentDoc}
${ProgramPreviewFragmentDoc}`;
export type GetHomeScreenComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetHomeScreenQuery, GetHomeScreenQueryVariables>, 'query'>;

    export const GetHomeScreenComponent = (props: GetHomeScreenComponentProps) => (
      <ApolloReactComponents.Query<GetHomeScreenQuery, GetHomeScreenQueryVariables> query={GetHomeScreenDocument} {...props} />
    );
    
export type GetHomeScreenProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetHomeScreenQuery, GetHomeScreenQueryVariables>
    } & TChildProps;
export function withGetHomeScreen<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetHomeScreenQuery,
  GetHomeScreenQueryVariables,
  GetHomeScreenProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetHomeScreenQuery, GetHomeScreenQueryVariables, GetHomeScreenProps<TChildProps, TDataName>>(GetHomeScreenDocument, {
      alias: 'getHomeScreen',
      ...operationOptions
    });
};

/**
 * __useGetHomeScreenQuery__
 *
 * To run a query within a React component, call `useGetHomeScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeScreenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHomeScreenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHomeScreenQuery, GetHomeScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHomeScreenQuery, GetHomeScreenQueryVariables>(GetHomeScreenDocument, options);
      }
export function useGetHomeScreenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHomeScreenQuery, GetHomeScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHomeScreenQuery, GetHomeScreenQueryVariables>(GetHomeScreenDocument, options);
        }
export type GetHomeScreenQueryHookResult = ReturnType<typeof useGetHomeScreenQuery>;
export type GetHomeScreenLazyQueryHookResult = ReturnType<typeof useGetHomeScreenLazyQuery>;
export type GetHomeScreenQueryResult = ApolloReactCommon.QueryResult<GetHomeScreenQuery, GetHomeScreenQueryVariables>;